import { createThemeCompiler } from '../../../utils';

export const treeViewThemeCompilier = createThemeCompiler(({ palette, stroke, boxShadow, borderRadius }) => ({
    treeView: {
        colors: {
            backgroundColor: palette.white,
            borderColor: palette.neutralQuaternary,
            item: {
                default: {
                    backgroundColor: palette.transparent,
                    borderColor: palette.transparent,
                    mainIcon: palette.neutralPrimary,
                    menuIcon: palette.neutralTertiary,
                    text: palette.neutralPrimary
                },
                expanded: {
                    backgroundColor: palette.transparent,
                    borderColor: palette.transparent,
                    mainIcon: palette.themePrimary,
                    menuIcon: palette.neutralTertiary,
                    text: palette.themePrimary
                },
                hovered: {
                    backgroundColor: palette.transparent,
                    borderColor: palette.transparent,
                    mainIcon: palette.themeLight,
                    menuIcon: palette.neutralSecondary,
                    text: palette.neutralSecondary
                },
                selected: {
                    backgroundColor: palette.themePrimary,
                    borderColor: palette.themePrimary,
                    mainIcon: palette.white,
                    menuIcon: palette.white,
                    text: palette.white
                }
            },
            modeIndicator: {
                backgroundColor: palette.white,
                iconColor: palette.themePrimary,
                borderColor: palette.white
            }
        },
        composites: {
            borderWidth: {
                item: stroke.none,
                modeIndicator: stroke.none,
                root: stroke.thin
            },
            borderRadius: {
                item: borderRadius.curvedMedium,
                modeIndicator: borderRadius.circle,
                root: borderRadius.curvedMedium
            },
            modeIndicatorBoxShadow: boxShadow.normal
        }
    }
}));
